<div class="content">
    <ng-content></ng-content>
</div>
<div class="options">
    <ng-template #optionsTarget></ng-template>
</div>
